import { RequestService } from './RequestService';

// The two save-offer endpoints (server/src/routes/saveOfferRouter.js, PR #106).
//
// Both are behind a token, because a save offer belongs to one account. The standalone
// goodbye page never calls either one: it is reached with nobody signed in, after the
// cancellation has already happened, so there is no renewal of a known studio to
// discount.
//
// offer() is a POST rather than a GET even though the screen is only asking a question,
// because answering it writes a row: the server records that the offer was put in front
// of this studio at the moment it is asked for. Without that write, the table cannot
// answer the question it exists for, which is how many of the studios we offered this to
// actually stayed.
export class SaveOfferService extends RequestService {

    offer = () => this.request('post', '', '', {});

    respond = (body) => this.request('post', 'respond', '', body);
}
